import extractSignature from '@/features/email/outlook/extractSignature';

const NO_SIGNATURE_PROMPT =
  'The user has no signature configured, so nothing will be appended below the reply. End the reply with an appropriate closing salutation. Do not invent contact details, job titles, or other signature information.';

const SIGNATURE_PROMPT =
  "The user has a signature configured, which will appear directly below the reply. Write the reply so it flows into the signature without repeating anything the signature already contains. In particular, if the signature already includes a closing salutation or the sender's name, do not add your own; if it doesn't, end the reply with an appropriate closing.";

export default function getConceptReplyPrompt(body: string): string {
  const signature = extractSignature(body);

  if (!signature) return NO_SIGNATURE_PROMPT;

  return `${SIGNATURE_PROMPT}\n\n<signature>\n${signature}\n</signature>`;
}
